import React, { useEffect, useState } from "react";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { Col, Row } from "react-bootstrap";
import { useGetAllConsultantListsQuery } from "../../../Service/consultant";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import AddConsultant from "./AddConsultant";
import { useDispatch, useSelector } from "react-redux";
import { Change } from "../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../Component/DigitalMarketing/Loader";
const ConsultantList = () => {
  const [show, setShow] = useState(false);
  const [updateData, setUpdateData] = useState<any>([]);
  const [pagination, setpagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const dispatch = useDispatch();
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const { data: consultantData, refetch,isLoading } = useGetAllConsultantListsQuery(
    pagi,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
  }, [searchValue]);

  useEffect(() => {
    const data: any = {
      first: "Consultant"
    };
    dispatch(Change(data));
  }, [show]);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox
            value={searchValue}
            onChange={(event) => onChangeSearch(event)}
          />
        </Col>
          <Col md={7} className="d-flex justify-content-end">
            <DashTabs
              setShow={setShow}
              show={show}
              setUpdateData={setUpdateData}
              // setView={setView}
            />
          </Col>
      </Row>

      <div className="row mt-3">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            consultantData={consultantData}
            setUpdateData={setUpdateData}
            // setView={setView}
            refetch={refetch}
          />
        </div>
        {show && (
          <div
            className="col-4 "
            style={{
              backgroundColor: "white",
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          >
            <AddConsultant
              setShow={setShow}
              refetch={refetch}
              updateData={updateData}
            />
          </div>
        )}
        <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={consultantData}
        />
      </div>
    </div>
  );
};

export default ConsultantList;
